import React from 'react';
import { ArrowLeft, Shield, Lock, Eye, FileText, Users, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      icon: <FileText size={24} />,
      title: "1. Загальні положення",
      content: `Ця Політика конфіденційності визначає порядок обробки та захисту персональних даних фізичних осіб, які звертаються до Юридичної компанії «PROTEGO» (далі — Компанія) за отриманням юридичних послуг.

Компанія здійснює обробку персональних даних відповідно до Закону України «Про захист персональних даних» від 01.06.2010 № 2297-VI, Загального регламенту захисту даних (GDPR) та інших нормативно-правових актів у сфері захисту персональних даних.`
    },
    {
      icon: <Users size={24} />,
      title: "2. Персональні дані, які ми збираємо",
      content: `Ми можемо збирати та обробляти наступні категорії персональних даних:

• Ідентифікаційні дані: прізвище, імʼя, по батькові
• Контактні дані: номер телефону, адреса електронної пошти, поштова адреса
• Дані щодо звернення: тема консультації, опис правової ситуації
• Технічні дані: IP-адреса, тип браузера, дані про відвідування веб-сайту

Ми збираємо лише ті персональні дані, які необхідні для надання вам якісних юридичних послуг.`
    },
    {
      icon: <Eye size={24} />,
      title: "3. Мета обробки персональних даних",
      content: `Персональні дані обробляються з метою:

• Надання юридичних консультацій та правової допомоги
• Укладення та виконання договорів про надання юридичних послуг
• Звʼязку з клієнтами для уточнення деталей справи
• Направлення інформаційних повідомлень про зміни в законодавстві
• Поліпшення якості наших послуг та роботи веб-сайту
• Виконання вимог законодавства України`
    },
    {
      icon: <Shield size={24} />,
      title: "4. Захист персональних даних",
      content: `Компанія вживає всіх необхідних організаційних та технічних заходів для захисту персональних даних від несанкціонованого доступу, знищення, модифікації або розкриття:

• Використання захищених серверів та шифрування даних
• Обмеження доступу до персональних даних тільки уповноваженим працівникам
• Регулярний аудит систем безпеки
• Дотримання адвокатської таємниці відповідно до Закону України «Про адвокатуру та адвокатську діяльність»`
    },
    {
      icon: <Lock size={24} />,
      title: "5. Права субʼєктів персональних даних",
      content: `Відповідно до законодавства, ви маєте право:

• Знати про джерела збирання, місцезнаходження своїх персональних даних
• Отримувати інформацію про умови надання доступу до персональних даних
• На доступ до своїх персональних даних
• Вимагати виправлення неточних або неповних даних
• Вимагати видалення персональних даних (право на забуття)
• Відкликати згоду на обробку персональних даних
• Подати скаргу до Уповноваженого Верховної Ради України з прав людини`
    },
    {
      icon: <FileText size={24} />,
      title: "6. Строк зберігання даних",
      content: `Персональні дані зберігаються протягом строку, необхідного для досягнення мети обробки, але не менше строків, встановлених законодавством:

• Дані клієнтів: протягом дії договору та 5 років після його закінчення
• Дані з форми зворотного звʼязку: 1 рік з моменту останнього контакту
• Технічні дані: до 1 року

Після закінчення строку зберігання персональні дані знищуються або знеособлюються.`
    },
    {
      icon: <Users size={24} />,
      title: "7. Передача даних третім особам",
      content: `Ми не передаємо ваші персональні дані третім особам, за винятком випадків:

• Отримання вашої попередньої згоди
• Виконання вимог законодавства України
• Захисту прав та законних інтересів Компанії
• Залучення інших адвокатів чи спеціалістів для надання послуг (за вашою згодою)

У разі передачі даних, ми гарантуємо дотримання конфіденційності та належний рівень захисту.`
    },
    {
      icon: <Mail size={24} />,
      title: "8. Контактна інформація",
      content: `З питань обробки персональних даних, реалізації ваших прав або подання скарг, ви можете звернутися до нас:

• Адреса: м. Дніпро, вул. Європейська, 28, офіс 505
• Телефон: +38 (056) 123-45-67
• Email: privacy@protego.ua

Ми відповімо на ваш запит протягом 30 календарних днів з дня отримання.`
    }
  ];

  return (
    <div className="page-wrapper">
      <div className="privacy-policy-page">
        <div className="privacy-header">
          <Button 
            onClick={() => navigate('/')} 
            className="btn-secondary back-button"
          >
            <ArrowLeft size={20} />
            На головну
          </Button>
          <h1 className="privacy-title">Політика конфіденційності</h1>
          <p className="privacy-subtitle">
            Юридична компанія «PROTEGO» дбає про захист ваших персональних даних
          </p>
          <p className="privacy-date">Остання редакція: грудень 2025</p>
        </div>

        <div className="privacy-content">
          {sections.map((section, index) => (
            <div key={index} className="privacy-section">
              <div className="privacy-section-header">
                <span className="privacy-section-icon">{section.icon}</span>
                <h2 className="privacy-section-title">{section.title}</h2>
              </div>
              <div className="privacy-section-content">
                {section.content.split('\n\n').map((paragraph, pIndex) => (
                  <p key={pIndex}>{paragraph}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="privacy-footer">
          <p>© 2025 PROTEGO. Всі права захищені.</p>
          <Button 
            onClick={() => navigate('/')} 
            className="btn-primary"
          >
            Повернутися на головну
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
